// @flow

import RoofSnapApiClient from "./roofSnapApiClient";

const baseUrl = 'projects';

type GetProjectParams = {
    id: string,
};

type GetProjectDrawingSummaryParams = {
    id: string,
};

class ProjectClient extends RoofSnapApiClient {
    async getProject(params: GetProjectParams) {
        const { id } = params;
        const url = `${baseUrl}/${id}`;
        return await super.get(url);
    }
    
    async getProjectDrawingSummary(params: GetProjectDrawingSummaryParams) {
        const { id } = params;
        const url = `${baseUrl}/${id}/projectdrawing/summary`;
        return await super.get(url);
    }
}

export default ProjectClient;
